import React from "react";

import svg from "../../assets/images/icons/Tester/run.svg";

export const RunIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run"}
    />
);
